<template>
  <div class="time-dropdown-wrapper">
    <select class="fauxselect" :data-selection="val" :id="id" v-model="val" @change="handleChange">
      <template v-if="id == 'timey'">
        <option disabled value="">Select a number of years</option>
        <option v-for="number in getRange(id)" :key="number" :value="number">
          {{ number === 0 ? 'Less than a year' : number + (number === 1 ? ' year' : ' years') }}
        </option>
      </template>
      <template v-if="id == 'timem'">
        <option disabled value="">Select a number of months</option>
        <option v-for="number in getRange(id)" :key="number" :value="number">
          {{ number + ' months' }}
        </option>
      </template>
    </select>
  </div>
</template>
  
<script>
  export default {
    name: 'numbChoose',
    data() {
      return {
        val: null
      };
    },
    props: {
      id: String,
      text: String,
      isPrevious: Boolean,
      yearsValue: [String, Number],
      value: [String, Number],
      editing: Boolean,
      timeAndAddressAdded: Boolean
    },
    methods: {
      getRange(id) {
        let result = [...Array((id === 'timey') ? 76 : 12).keys()];
        if (id == 'timem' && this.yearsValue == 0 && this.isPrevious) {
          result.shift();
        }
        return result;
      },
      handleChange(event) {
        this.val = event.target.value;
        this.$emit('update:value', this.val);

        // Additional logic to handle the months when years change
        if (this.id === 'timey' && this.val == 0 && this.isPrevious) {
          this.$emit('reset-months');
        }
      },
      reset() {
        this.selectopen = false;
        this.changed = false;
        this.val = null;
      } 
    },
    watch: {
      value: {
        immediate: true,
        handler(value) {
          if (value == null) {
            this.val = "";
          } else {
            this.val = value;
          }
        }
      }
    }
  }
  </script>
  
  <style scoped src="@/v1/assets/css/address.css"></style>
  